import { Injectable } from '@angular/core';
import { IProductBase, IProductCreationParams } from 'model/product.interface';

@Injectable({
  providedIn: 'root'
})
export class FlyProductService {

    private readonly CATEGORY_ID = 3;
    private readonly CATEGORY_NAME = 'FLIGHTS';

    private form: any

      createProduct(params: IProductCreationParams): IProductBase {

        return;
      }
}
